export default "__VITE_ASSET__B21f6BFk__"